var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HorizontalMenu',{attrs:{"items":_vm.items,"value":_vm.selectedTab,"size":"small","bottomLine":true},on:{"onChange":function($event){return _vm.$emit('onChange', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }